export default __webpack_public_path__ + "static/media/kia.b161eadd.svg";